(() => {
  function init(scope = document) {
    scope.querySelectorAll('.ss-gallery:not([data-ready])').forEach(gallery => {
      gallery.dataset.ready = 'true';
      const slides = [...gallery.querySelectorAll('.ss-slide')];
      let current = 0;
      const controls = document.createElement('div');
      controls.className = 'ss-gallery-controls';
      const thumbs = document.createElement('div');
      thumbs.className = 'ss-thumbnails';
      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        [...thumbs.children].forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
      };
      for (const [step, symbol, label] of [[-1, '❮', gallery.dataset.previous], [1, '❯', gallery.dataset.next]]) {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'ss-gallery-arrow'; button.textContent = symbol;
        button.setAttribute('aria-label', label); button.disabled = slides.length < 2;
        button.addEventListener('click', () => show(current + step)); controls.append(button);
      }
      slides.forEach((slide, i) => {
        const button = document.createElement('button'); button.type = 'button';
        button.setAttribute('aria-label', `${gallery.dataset.show} ${i + 1}`);
        const image = slide.querySelector('img').cloneNode(); image.removeAttribute('class'); image.alt = '';
        button.append(image); button.addEventListener('click', () => show(i)); thumbs.append(button);
      });
      gallery.querySelector('.ss-gallery-stage').append(controls); gallery.append(thumbs); show(0);
      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); show(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    });
    scope.querySelectorAll('[data-ss-product]:not([data-bound])').forEach(panel => {
      panel.dataset.bound = 'true';
      const form = panel.querySelector('.ss-buy-form');
      const variants = form ? JSON.parse(form.querySelector('[data-ss-variants]').textContent) : [];
      panel.addEventListener('click', event => {
        const size = event.target.closest('[data-size]'); if (!size) return;
        panel.querySelectorAll('[data-size]').forEach(button => button.setAttribute('aria-pressed', String(button === size)));
        const selected = size.dataset.size;
        const normalize = value => value.split(' ')[0].replace('2XL', 'XXL');
        const variant = variants.find(v => v.options.some(o => normalize(o) === normalize(selected)));
        const status = panel.querySelector('#size-status'); if (status) status.textContent = selected;
        if (!form) return;
        form.querySelector('[data-ss-variant]').value = variant ? variant.id : '';
        form.querySelector('[type=submit]').disabled = !variant || !variant.available;
        const message = form.querySelector('.ss-purchase-status');
        message.textContent = variant && variant.available ? selected : message.dataset.unavailable;
      });
      if (form) form.addEventListener('submit', event => {
        if (form.querySelector('[type=submit]').disabled || !form.querySelector('[data-ss-variant]').value) event.preventDefault();
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
